import { __assign, __rest } from "tslib";
import { ItemType, } from '../domain';
export var DEFAULT_PAGE = 1;
export var DEFAULT_PAGE_SIZE = 50;
var getArticleUri = function (baseUrl, articleId) { return baseUrl + "/articles/" + articleId; };
export var createArticlesApi = function (baseUrl, http) {
    var articlesApi = {
        adminSearch: function (dto) {
            return http.post(baseUrl + "/articles/search/admin", dto);
        },
        search: function (dto) {
            return http.post(baseUrl + "/articles/search", dto);
        },
        getArticle: function (dto) {
            return http.get(getArticleUri(baseUrl, dto.id) + "?locale=" + dto.locale);
        },
        getArticleByUri: function (dto) {
            return http.get(baseUrl + "/articles/uri/" + dto.uri + "?locale=" + dto.locale);
        },
        getExtendedArticle: function (dto) {
            return http.get(getArticleUri(baseUrl, dto.id) + "/extended?locale=" + dto.locale);
        },
        getArticleTasks: function (dto) {
            return http.get(baseUrl + "/articles/" + dto.id + "/tasks?locale=" + dto.locale + "&page=" + (dto.page || DEFAULT_PAGE) + "&pageSize=" + (dto.pageSize || DEFAULT_PAGE_SIZE));
        },
        getArticleTask: function (dto) {
            return http.get(baseUrl + "/articles/" + dto.id + "/tasks/" + dto.taskId + "?locale=" + dto.locale);
        },
        addArticle: function (dto) { return http.post(baseUrl + "/articles", dto); },
        saveArticle: function (dto) { return http.put(getArticleUri(baseUrl, dto.id), dto); },
        unpublishArticle: function (dto) { return http.post(getArticleUri(baseUrl, dto.id) + "/unpublish", dto); },
        deleteArticle: function (dto) { return http.delete(getArticleUri(baseUrl, dto.id) + "?locale=" + dto.locale); },
        saveAndPublishArticle: function (dto) { return http.post(getArticleUri(baseUrl, dto.id) + "/publish", dto); },
        getArticleListPresenceInfo: function (dto) {
            return http.post(baseUrl + "/articles/presence", dto);
        },
        getArticlePresenceInfo: function (dto) {
            return http.get(getArticleUri(baseUrl, dto.id) + "/presence?locale=" + dto.locale + "&maxAge=5");
        },
        reportArticlePresence: function (dto) {
            return http.post(getArticleUri(baseUrl, dto.id) + "/presence", __assign(__assign({}, dto), { itemType: ItemType.ARTICLE }));
        },
        deleteArticlePresence: function (dto) {
            return http.delete(getArticleUri(baseUrl, dto.id) + "/presence?locale=" + dto.locale + "&itemType=" + ItemType.ARTICLE);
        },
        getArticleCounters: function (dto) {
            return http.get(getArticleUri(baseUrl, dto.id) + "/counters?locale=" + dto.locale);
        },
        moveArticleToCategory: function (dto) {
            var requestBody = {
                categoryId: dto.categoryId
            };
            return http.post(getArticleUri(baseUrl, dto.id) + "/move", requestBody);
        },
        getArticleActivityEvents: function (_a) {
            var locale = _a.locale, id = _a.id, _b = _a.page, page = _b === void 0 ? 1 : _b, _c = _a.pageSize, pageSize = _c === void 0 ? 200 : _c;
            // tslint:disable-next-line: max-line-length
            return http.get(baseUrl + "/history/item?itemId=" + id + "&locale=" + locale + "&itemType=" + ItemType.ARTICLE + "&page=" + page + "&pageSize=" + pageSize);
        },
        getRelatedArticles: function (dto) {
            return http.get(getArticleUri(baseUrl, dto.id) + "/relations/admin?locale=" + dto.locale);
        },
        getHelpcenterRelatedArticles: function (dto) {
            return http.get(getArticleUri(baseUrl, dto.id) + "/relations?locale=" + dto.locale);
        },
        addRelatedArticle: function (dto) {
            return http.post(getArticleUri(baseUrl, dto.id) + "/relations", {
                relatedId: dto.relatedId,
                doInAllLangs: dto.doInAllLangs || false,
                locale: dto.locale
            });
        },
        sortRelatedArticles: function (dto) {
            return http.post(getArticleUri(baseUrl, dto.id) + "/relations/sort", {
                relatedIds: dto.relatedIds,
                locale: dto.locale
            });
        },
        removeRelatedArticle: function (dto) {
            return http.delete(getArticleUri(baseUrl, dto.id) + "/relations/" + dto.relatedId + "?locale=" + dto.locale + (dto.doInAllLangs ? "&doInAllLangs=" + dto.doInAllLangs : ''));
        },
        updateLabels: function (dto) {
            return http.put(getArticleUri(baseUrl, dto.id) + "/labels", {
                locale: dto.locale,
                addedLabelIds: dto.addedLabelIds,
                removedLabelIds: dto.removedLabelIds
            });
        },
        updateArticleType: function (dto) {
            return http.post(getArticleUri(baseUrl, dto.id) + "/changeType", {
                type: dto.type
            });
        },
        updateArticleResolution: function (dto) {
            return http.post(getArticleUri(baseUrl, dto.id) + "/setResolution", {
                resolution: dto.resolution,
                notify: dto.notify,
                locales: dto.locales
            });
        },
        addTask: function (dto) {
            return http.post(getArticleUri(baseUrl, dto.id) + "/tasks", {
                locale: dto.locale,
                type: dto.type,
                priority: dto.priority,
                description: dto.description,
                assignedUserId: dto.assignedUserId
            });
        },
        updateTask: function (dto) {
            return http.put(getArticleUri(baseUrl, dto.id) + "/tasks/" + dto.taskId, {
                locale: dto.locale,
                type: dto.type,
                priority: dto.priority,
                description: dto.description,
                assignedUserId: dto.assignedUserId,
            });
        },
        addTaskComment: function (dto) {
            var id = dto.id, taskId = dto.taskId, rest = __rest(dto, ["id", "taskId"]);
            return http.post(getArticleUri(baseUrl, id) + "/tasks/" + taskId + "/notes", rest);
        },
        completeTask: function (dto) {
            var id = dto.id, taskId = dto.taskId;
            return http.post(getArticleUri(baseUrl, id) + "/tasks/" + taskId + "/complete", {});
        },
        deleteTask: function (dto) {
            var id = dto.id, taskId = dto.taskId, locale = dto.locale;
            return http.delete(getArticleUri(baseUrl, id) + "/tasks/" + taskId + "?locale=" + locale);
        },
        editTaskComment: function (dto) {
            var id = dto.id, taskId = dto.taskId, noteId = dto.noteId, rest = __rest(dto, ["id", "taskId", "noteId"]);
            return http.put(getArticleUri(baseUrl, id) + "/tasks/" + taskId + "/notes/" + noteId, rest);
        },
        removeTaskComment: function (dto) {
            var id = dto.id, taskId = dto.taskId, noteId = dto.noteId, locale = dto.locale;
            return http.delete(getArticleUri(baseUrl, id) + "/tasks/" + taskId + "/notes/" + noteId + "?locale=" + locale);
        },
        reopenTask: function (dto) {
            var id = dto.id, taskId = dto.taskId;
            return http.post(getArticleUri(baseUrl, id) + "/tasks/" + taskId + "/open", {});
        },
        getArticleNotes: function (dto) {
            var id = dto.id, locale = dto.locale;
            return http.get(getArticleUri(baseUrl, id) + "/notes?locale=" + locale);
        },
        addArticleNote: function (dto) {
            var id = dto.id, rest = __rest(dto, ["id"]);
            return http.post(getArticleUri(baseUrl, id) + "/notes", rest);
        },
        deleteArticleNote: function (dto) {
            var id = dto.id, noteId = dto.noteId, locale = dto.locale;
            return http.delete(getArticleUri(baseUrl, id) + "/notes/" + noteId + "?locale=" + locale);
        },
        updateArticleNote: function (dto) {
            var id = dto.id, noteId = dto.noteId, locale = dto.locale, content = dto.content;
            return http.put(getArticleUri(baseUrl, id) + "/notes/" + noteId, { text: content, locale: locale });
        },
        updateArticleKeywords: function (dto) {
            var id = dto.id, locale = dto.locale, textValues = dto.textValues;
            return http.put(getArticleUri(baseUrl, id) + "/phrases", { textValues: textValues, locale: locale });
        },
        getArticleVersions: function (dto) {
            var id = dto.id, locale = dto.locale;
            return http.get(getArticleUri(baseUrl, id) + "/versions?locale=" + locale).then(function (versions) {
                return versions.map(function (version) {
                    if (version.lastUpdateDate > 1455746400000 && version.lastUpdateDate < 1455832799000) {
                        return __assign(__assign({}, version), { lastUpdateDate: version.creationDate });
                    }
                    return version;
                });
            });
        },
        addArticleComment: function (dto) {
            var id = dto.id, rest = __rest(dto, ["id"]);
            return http.post(getArticleUri(baseUrl, id) + "/comments", rest);
        },
        getArticleComments: function (dto) {
            var id = dto.id, locale = dto.locale;
            return http.get(getArticleUri(baseUrl, id) + "/comments?locale=" + locale);
        },
        setArticleCommentResolved: function (dto) {
            var resolved = dto.resolved, commentId = dto.commentId, id = dto.id;
            return http.put(getArticleUri(baseUrl, id) + "/comments/" + commentId + "/resolved", { resolved: resolved });
        },
        setArticleCommentContent: function (dto) {
            var content = dto.content, commentId = dto.commentId, id = dto.id;
            return http.put(getArticleUri(baseUrl, id) + "/comments/" + commentId, { content: content });
        },
        deleteArticleComment: function (dto) {
            var commentId = dto.commentId, id = dto.id;
            return http.delete(getArticleUri(baseUrl, id) + "/comments/" + commentId);
        },
        addArticleCommentReply: function (dto) {
            var id = dto.id, commentId = dto.commentId, rest = __rest(dto, ["id", "commentId"]);
            return http.post(getArticleUri(baseUrl, id) + "/comments/" + commentId + "/replies", rest);
        },
        getArticleCommentReplies: function (dto) {
            var id = dto.id, commentId = dto.commentId;
            return http.get(getArticleUri(baseUrl, id) + "/comments/" + commentId + "/replies");
        },
        setArticleCommentReplyContent: function (dto) {
            var id = dto.id, commentId = dto.commentId, commentReplyId = dto.commentReplyId, content = dto.content;
            return http.put(getArticleUri(baseUrl, id) + "/comments/" + commentId + "/replies/" + commentReplyId, { content: content });
        },
        deleteArticleCommentReply: function (dto) {
            var id = dto.id, commentId = dto.commentId, commentReplyId = dto.commentReplyId;
            return http.delete(getArticleUri(baseUrl, id) + "/comments/" + commentId + "/replies/" + commentReplyId);
        },
        saveArticleComment: function (dto) { return http.put(getArticleUri(baseUrl, dto.id) + "/comments", dto); },
        voteOnIssueOrFeature: function (dto) { return http.post(getArticleUri(baseUrl, dto.id) + "/vote", dto); },
        unvoteOnIssueOrFeature: function (dto) { return http.delete(getArticleUri(baseUrl, dto.id) + "/vote?locale=" + dto.locale); },
        sendFeedback: function (dto) { return http.post(getArticleUri(baseUrl, dto.id) + "/helpful", dto); },
        // bulk actions
        deleteArticles: function (dto) { return http.post(baseUrl + "/articles/delete", dto); },
        unpublishArticles: function (dto) { return http.post(baseUrl + "/articles/unpublish", dto); },
        publishArticles: function (dto) { return http.post(baseUrl + "/articles/publish", dto); },
        moveArticlesToCategory: function (dto) { return http.post(baseUrl + "/articles/move", dto); },
        editArticlesLabels: function (dto) { return http.put(baseUrl + "/articles/labels", dto); },
        addArticlesTask: function (dto) { return http.post(baseUrl + "/articles/tasks", dto); },
        addArticlesTranslations: function (dto) { return http.post(baseUrl + "/articles/translations", dto); },
    };
    return articlesApi;
};
//# sourceMappingURL=index.js.map